import makeStyles from '@material-ui/core/styles/makeStyles';

const colorBlue = '#2E3092';
const useStyles = makeStyles(() => ({
    primary: {
        borderRadius: 7,
        background: colorBlue,
        color: '#FFFFFF',
        letterSpacing: 1,
        fontSize: 15,
        '&:hover': {
            background: colorBlue,
        },
    },
    outlined: {
        borderRadius: 7,
        background: 'transparent',
        border: `1px solid ${colorBlue}`,
        padding: '5px 16px',
        color: colorBlue,
        fontWeight: 400,
        textTransform: 'unset',
        letterSpacing: 0,
        boxShadow: 'none',
        '&:hover': {
            background: 'transparent',
        },
    },
    rounded: {
        borderRadius: 20,
        fontWeight: 400,
        textTransform: 'unset',
        letterSpacing: 0,
    },
    buttonText: {
        background: 'none',
        color: colorBlue,
        fontWeight: 600,
        textTransform: 'unset',
        letterSpacing: 0,
        boxShadow: 'none',
        textDecoration: 'underline',
        '&:hover': {
            background: 'none',
            boxShadow: 'none',
            color: colorBlue,
            textDecoration: 'underline',
        },
    },
    link: {
        background: 'none',
        color: '#536777',
        fontWeight: 400,
        textTransform: 'unset',
        letterSpacing: 0,
        boxShadow: 'none',
        '&:hover': {
            background: 'none',
            boxShadow: 'none',
            color: '#000000',
        },
    },
}));

export default useStyles;
